import type { IVehicle } from '@makemydeal/dr-platform-types';
import { useMemo } from 'react';

import { isValidVehicle } from './isValidVehicle';

export const useValidateVehicle = (vehicle: IVehicle): boolean | undefined => {
    return useMemo(() => {
        const { vin, stockNumber, chromeStyleId } = vehicle;

        if ((stockNumber && vin) || chromeStyleId) {
            return isValidVehicle(vehicle);
        }

        return undefined;
    }, [vehicle]);
};
